import { render, staticRenderFns } from "./BindingSalesman.vue?vue&type=template&id=2c609c4f&scoped=true"
import script from "./BindingSalesman.vue?vue&type=script&lang=js"
export * from "./BindingSalesman.vue?vue&type=script&lang=js"
import style0 from "./BindingSalesman.vue?vue&type=style&index=0&id=2c609c4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c609c4f",
  null
  
)

export default component.exports